import React, { memo, useEffect, useState } from "react";
import { useAppDispatch } from "../redux/store/hooks";
import { useNavigate } from "react-router-dom";
import { setThread } from "../redux/actions";
import { Image, Skeleton } from "antd";
import NumberOfMentions from "./NumberOfMentions";
import { referencesService } from "../api";

type Props = {
  item: any;
  date: string[]
};

const RegionCard: React.FC<Props> = ({ item, date }: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [loadingPost, setLoadingPost] = useState(true);
  const nowDate = new Date().toJSON().split("T")[0];
  const [regionData, setRegionData] = useState<any>([]);

  useEffect(() => {
    setLoadingPost(true);
    let params = {
      thread_id: +item?.id,
      date_from: date[0],
      date_to: date[1],
    };

    referencesService
      .loadRegions(params)
      .then((list: any) => {
        setRegionData([list?.failures, list?.errors]);
        setLoadingPost(false);
      })
      .catch((err) => console.log(err));
  }, [date]);

  return (
    <>
      {loadingPost ? (
        <>
          <Skeleton
            active
            avatar
            loading={loadingPost}
            paragraph={{ rows: 4 }}
          />
        </>
      ) : (
        <div
          className="grid-block white-block btn-cursor grid1_3"
          key={item?.id}
          onClick={() => {
            dispatch(setThread(item));
            navigate(`/factory/${item?.id}`);
          }}
        >
          <Image src={`/coats/${item?.id}.webp`} alt=""></Image>
          <div>
            <p className="title-small">{item?.threadname}</p>

            {regionData[1].data.reduce(
              (acc: number, cur: number) => acc + cur,
              0
            ) < 200 ? (
              <p className="green">
                <b>Умеренный фон</b>
              </p>
            ) : (
              <p className="red">
                <b>Проблемы с доступом</b>
              </p>
            )}
            <p>
              Отключений за последний час:{" "}
              <b>
                {regionData[0].data
                  .slice(-2)
                  .reduce((acc: number, cur: number) => acc + cur / 96, 0)
                  .toFixed(2)}
              </b>
              %
            </p>
            <p>
              Отключений за последние сутки:{" "}
              <b>
                {regionData[0].data
                  .reduce((acc: number, cur: number) => acc + cur / 96, 0)
                  .toFixed(2)}
              </b>
              %
            </p>
            <p>
              Сообщений за последние сутки:{" "}
              <b>
                {regionData[1].data.reduce(
                  (acc: number, cur: number) => acc + cur,
                  0
                )}
              </b>
            </p>
            {regionData.length == 2 && (
              <NumberOfMentions refer={"single"} data={regionData} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default memo(RegionCard);
